const SIMILAR_CATEGORY = '비슷한문장';

export const hasExplicitSimilarLevelDistribution = (value) => (
  Boolean(value)
  && typeof value === 'object'
  && ['상', '중', '하'].some((level) => Number(value[level]) > 0)
);

const MAX_EVALUATION_CONTEXT_CHARS = 1500;

// 학생별 관찰 내용이 섞인 활동 내용은 넣지 않고, 성취기준·평가요소처럼 반 전체에 공통인 맥락만 넘긴다.
export const buildSimilarEvaluationContext = (category, { subjectActivityName = '', highSchoolAchievement = '' } = {}) => {
  let text = '';
  if (category === '교과') text = subjectActivityName;
  else if (category === '교과_고등') text = highSchoolAchievement;
  return String(text || '').trim().slice(0, MAX_EVALUATION_CONTEXT_CHARS);
};

export const resolveSimilarLaunchContext = (text, extras = {}, context = {}) => {
  const next = String(text || '').trim();
  if (!next) return null;

  const rawHint = extras.categoryHint || context.resultCategory || context.selectedCategory || '';
  const categoryHint = rawHint && rawHint !== SIMILAR_CATEGORY ? rawHint : '';
  const requestedBytes = Number(extras.targetBytes);
  const targetBytes = Number.isFinite(requestedBytes) && requestedBytes >= 100
    ? requestedBytes
    : 0;

  return {
    text: next,
    categoryHint,
    targetBytes,
  };
};
